import Logo from "@/components/site/Logo";

const VALUES = [
    {
        title: "Shopper First",
        body:
            "Every decision starts with the question: does this make the in-store experience better, faster, or more delightful for the shopper?",
    },
    {
        title: "Retailer ROI",
        body:
            "We measure success in shrink reduction, dwell time, conversion lift and net-new revenue — not vanity metrics.",
    },
    {
        title: "Privacy by Design",
        body:
            "On-device inference, anonymous shopper journeys and explicit consent at every touchpoint.",
    },
    {
        title: "Open Architecture",
        body:
            "Every module ships with documented APIs and webhooks. No vendor lock-in. Plug into your POS, ERP, loyalty and ad-tech stack.",
    },
    {
        title: "Honest Roadmap",
        body:
            "We publish what's in test, what's in development and what's planned. No fake-shipping claims — only what we can demonstrate.",
    },
];

export default function About() {
    return (
        <section
            id="company"
            data-testid="about-section"
            className="relative bg-rt-bg py-24 lg:py-36 border-t border-white/10"
        >
            <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
                <div className="grid lg:grid-cols-12 gap-12">
                    <div className="lg:col-span-5">
                        <div className="rt-eyebrow mb-4">Company / ReTechler</div>
                        <h2 className="rt-h2 text-4xl md:text-5xl lg:text-6xl text-white">
                            A retail-tech company building the platform we wished existed.
                        </h2>
                        <p className="mt-6 text-rt-text2 text-base lg:text-lg max-w-lg leading-relaxed">
                            ReTechler is an independent retail-tech company. Our mission is to make
                            every physical store as intelligent, convenient and data-rich as the best
                            e-commerce experience — while preserving everything that makes in-person
                            shopping irreplaceable.
                        </p>
                        <p className="mt-4 text-rt-text2 text-base lg:text-lg max-w-lg leading-relaxed">
                            We are starting with what shoppers touch most: the cart. Our first
                            product line, <a
                                href="https://smartcaddy.store/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-rt-teal underline decoration-rt-teal/40 underline-offset-4 hover:decoration-rt-teal"
                            >SmartCaddy</a>, is in active development — Caddy is in test today,
                            with Caddy Pro, Caddy Vision and Cobot following on the roadmap.
                        </p>

                        <div className="mt-10 inline-flex items-center gap-3 border border-white/10 bg-rt-surface px-5 py-4">
                            <Logo height={28} />
                            <span className="text-xs font-mono uppercase tracking-[0.2em] text-rt-text3">
                                Independent · Operator-led
                            </span>
                        </div>
                    </div>

                    <div className="lg:col-span-7 lg:pl-12 lg:border-l lg:border-white/10">
                        <div className="rt-eyebrow mb-4">Operating values</div>
                        <h3 className="rt-h2 text-3xl md:text-4xl text-white mb-10">
                            Five rules that decide every shipped feature.
                        </h3>
                        <div className="space-y-1">
                            {VALUES.map((v, i) => (
                                <div
                                    key={i}
                                    data-testid={`value-${i}`}
                                    className="grid grid-cols-[3rem_1fr] md:grid-cols-[4rem_1fr_1fr] gap-6 py-7 border-t border-white/10 group"
                                >
                                    <div className="font-mono text-rt-text3 text-sm">
                                        0{i + 1}
                                    </div>
                                    <div className="font-heading text-xl md:text-2xl text-white tracking-tight group-hover:text-rt-teal transition-colors">
                                        {v.title}
                                    </div>
                                    <div className="hidden md:block text-sm text-rt-text2">
                                        {v.body}
                                    </div>
                                    <div className="md:hidden col-span-2 text-sm text-rt-text2">
                                        {v.body}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
